import React, { useEffect, useRef, useState } from "react";
import { Form, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import InputForm from "../command/input/inputField";
import "./rentalSummaryDetails.scss";
import PaymentCard from "../command/paymentCard/paymentCard";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation } from "swiper/modules";
import { ArrowRight, Info, Plus } from "react-feather";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { orderClient } from "../../data/order";
import SwiperCore, { Swiper as SwiperInstance } from "swiper";
import { getAuthCredentials } from "../../utils/auth-utils";
import creditCardType from "credit-card-type";
import valid from "card-validator";
import { useTranslation } from "react-i18next";
import PaymentForm from "./paymentForm";

interface PaymentCardModalProps {
  show: boolean;
  cardlist: any;
  sessionid: string;
  customerinfo: any;
  orderdetails: any;
  producttotalrate: number;
  onHide: () => void;
}
SwiperCore.use([FreeMode, Navigation]);

const PaymentModal: React.FC<PaymentCardModalProps> = ({
  onHide,
  ...props
}) => {
  const [swiper, setSwiper] = useState<SwiperInstance | null>(null);
  const [isSwiperDisabled, setIsSwiperDisabled] = useState(false);
  const [totalPayableAmount, setTotalPayableAmount] = useState<any>(0);
  const { t } = useTranslation();
  const publicKey = process.env.REACT_APP_ACQUIRED_PUBLIC_KEY ?? "";
  const handleToggleSwiper = () => {
    if (swiper) {
      if (isSwiperDisabled) {
        swiper.allowSlideNext = true;
        swiper.allowSlidePrev = true;
        // Show navigation buttons
        const nextButton = swiper.navigation.nextEl;
        const prevButton = swiper.navigation.prevEl;
        if (nextButton) nextButton.style.display = "";
        if (prevButton) prevButton.style.display = "";
      } else {
        swiper.allowSlideNext = false;
        swiper.allowSlidePrev = false;
        // Hide navigation buttons
        const nextButton = swiper.navigation.nextEl;
        const prevButton = swiper.navigation.prevEl;
        if (nextButton) nextButton.style.display = "none";
        if (prevButton) prevButton.style.display = "none";
      }
      setIsSwiperDisabled(!isSwiperDisabled);
    }
  };

  const [selectdCard, setSelectdCard] = useState<any>();
  const handleCVVChange = (value: string, error: boolean, cardDetails: any) => {
    setSelectdCard(cardDetails);
  };
  const [showNewCardForm, setShowNewCardForm] = useState(true);
  const handleAddCardClick = () => {
    setShowNewCardForm(!showNewCardForm);
  };
  const [acquiredLoaded, setAcquiredLoaded] = useState(false);

  const loadAcquiredScript = () => {
    const script = document.createElement("script");
    const scriptUrl = process.env.REACT_APP_ACQUIRED_SRC_URL;
    script.src = scriptUrl!;
    script.async = true;
    script.integrity = process.env.REACT_APP_ACQUIRED_INTEGRAITY_KEY!;
    script.crossOrigin = process.env.REACT_APP_ACQUIRED_CROSSORIGIN_METHOD!;
    script.onload = () => setAcquiredLoaded(true);
    document.body.appendChild(script);
  };

  (function (global) {
    if (!global.Acquired) {
      global.Acquired = {}; // Initialize Acquired only if it doesn't exist
      // Your script logic here
      if (window.Acquired && !acquiredLoaded) {
        // `Acquired` is already defined and is a constructor function
        setAcquiredLoaded(true);
        loadAcquiredScript();
        return;
      }
    }
  })(window);

  const [submitted, setSubmitted] = useState<boolean>(false);

  const handleSubmit = () => {
    setSubmitted(true); // Handle the submit logic here
  };

  useEffect(() => {
    if (props) {
      setTotalPayableAmount(
        (
          Number(props.producttotalrate) +
          Number(props?.orderdetails?.totalDepositAmount)
        ).toFixed(2)
      );
    }
  }, [props]);

  return (
    <div>
      <Modal
        {...props}
        aria-labelledby="payment-modal"
        centered
        backdrop="static"
        onHide={onHide}
        // size="lg"
        className="payment-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="payment-modal">
            {/* Add Your Payment Card */}
            {t("payment-method")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <PaymentForm
              customerinfo={props?.customerinfo}
              sessionid={props?.sessionid}
              publicKey={publicKey}
              orderdetails={props?.orderdetails}
              producttotalrate={props?.producttotalrate}
              totalPayablAmount={totalPayableAmount}
            />
         
          {/* {props.cardlist && props.cardlist?.length <= 0 ? (
            <></>
          ) : (
            <div className="save-card-wrapper">
              {props.cardlist && props.cardlist?.length > 0 && (
                <div className="active-cards">
                  <h5>
                    {showNewCardForm ? t("saved-cards") : t("add-new-card")}
                  </h5>
                  <p>
                    {showNewCardForm
                      ? `${t("you-have")} ${props.cardlist?.length} ${t(
                          "active-card"
                        )}s`
                      : ""}
                  </p>
                </div>
              )}
              {showNewCardForm ? (
                <Swiper
                  spaceBetween={15}
                  slidesPerView={"auto"}
                  freeMode={props.cardlist?.length === 1 ? false : true}
                  navigation={true} // Enable navigation
                  modules={[FreeMode, Navigation]}
                  className="swiper-card"
                  onSwiper={setSwiper}
                  centeredSlides={props.cardlist?.length === 1 ? true : false}
                >
                  {props?.cardlist.map((item: any, index: number) => (
                    <SwiperSlide key={index} style={{ width: "auto" }}>
                      <PaymentCard
                        sessionid={props?.sessionid}
                        publicKey={publicKey}
                        cardlist={item}
                        onCVVChange={handleCVVChange}
                        onToggleSwiper={handleToggleSwiper}
                        cardCvvComponent={`card-cvv-component${index}`}
                        componentError={`component-error${index}`}
                        submitted={submitted}
                        setSubmitted={setSubmitted}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              ) : (
                <PaymentForm
                  customerinfo={props?.customerinfo}
                  sessionid={props?.sessionid}
                  publicKey={publicKey}
                  orderdetails={props?.orderdetails}
                  producttotalrate={props?.producttotalrate}
                  handleAddCardClick={handleAddCardClick}
                  showNewCardForm={showNewCardForm}
                  totalPayablAmount={totalPayableAmount}
                />
              )}
              {showNewCardForm && (
                <div className="add-payment-card">
                  <div className={`btn add-card`} onClick={handleAddCardClick}>
                    <>
                      Add new card <Plus size={20} className="mb-1" />
                    </>
                  </div>
                </div>
              )}
              {showNewCardForm ? (
                <div className="payment-details-section">
                  <div className="row">
                    <div className="col-12">
                      <div className="total-payment-amount">
                        <div>
                          <h4>
                            {t("rental-to-pay-today")} : £
                            {props?.producttotalrate}
                          </h4>
                          <p>
                            <OverlayTrigger
                              key="right"
                              placement="right"
                              overlay={
                                <Tooltip
                                  id={`tooltip-right`}
                                  style={{ position: "fixed" }}
                                >
                                  {t("refundable-deposit-tooltip")}
                                </Tooltip>
                              }
                            >
                              <Info className="info-icon me-1" size={18} />
                            </OverlayTrigger>
                            + {t("refundable-deposit-of")} £
                            {props?.orderdetails?.totalDepositAmount.toFixed(2)}
                            .
                          </p>
                        </div>
                      </div>
                      <button
                        id="submit"
                        onClick={() => handleSubmit()}
                        className={`btn primary-btn payment-btn`}
                      >
                        {t("pay-now")}{" "}
                        <span>£{(totalPayableAmount ?? 0).toFixed(2)}</span>
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
          )} */}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default PaymentModal;
